const AdditionalRequestList = async () =>
    import('../../pages/additional-requests/List').then((module) => ({
        Component: module.AdditionalRequestList,
    }));
const AdditionalRequestView = async () =>
    import('../../pages/additional-requests/View').then((module) => ({
        Component: module.AdditionalRequestView,
    }));

const getAdditionalRequestRoutes = () => {
    return [
        {
            path: '/additional-requests/',
            lazy: AdditionalRequestList,
        },
        {
            path: '/additional-requests/new',
            lazy: AdditionalRequestList,
        },
        {
            path: '/additional-requests/:additionalRequestId/',
            lazy: AdditionalRequestView,
        },
        {
            path: '/additional-requests/:additionalRequestId/edit',
            lazy: AdditionalRequestView,
        },
    ];
};

export { getAdditionalRequestRoutes };
